import * as React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
import {RowIcon} from 'shells/row/row-icon';
import type {Option} from 'shells/select-picker-generic/types';

import type {GetMarketForLead_lead_market as Market} from 'nutshell-graphql-types';

import {ReduxSelectProducts} from '../../../../core/select/redux-select-products';

import styles from '../../sidebar.module.css';

type Props = {
    currentMarket: Market;
    onSelect: (product: Option) => void;
    onCancel: () => void;
};

export function ProductsRowCreateForm(props: Props) {
    return (
        <div className='flex gap-8 flex-dir-row px-12 py-8 border-box'>
            <div className={styles['select-create-form-row-icon']}>
                <RowIcon type='products' />
            </div>
            <div className='flex gap-4 justify-sb full-width'>
                <div className='full-width'>
                    <ReduxSelectProducts
                        onChange={props.onSelect}
                        selectedId={null}
                        size='mini'
                        hideDivider={true}
                        currentMarket={{
                            id: props.currentMarket.id,
                            type: 'markets',
                            name: props.currentMarket.name,
                            currency: props.currentMarket.currency,
                            currencySymbol: props.currentMarket.currencySymbol,
                            isDefault: props.currentMarket.isDefault,
                        }}
                        menuZIndex={11}
                    />
                </div>
                <CloseButton variant='dark' onClick={props.onCancel} size={10} />
            </div>
        </div>
    );
}
